export default "__VITE_ASSET__euESdOnG__"